module.exports = __webpack_public_path__ + "image/ewm1.png";